<script setup lang="ts">
defineProps<{
  variant?: 'primary' | 'outline'
  type?: 'button' | 'submit' | 'reset'
  disabled?: boolean
}>()

defineEmits<{
  click: [event: MouseEvent]
}>()
</script>

<template>
  <button
    :class="['base-btn', `btn-${variant ?? 'primary'}`]"
    :type="type ?? 'button'"
    :disabled="disabled"
    @click="$emit('click', $event)"
  >
    <span><slot /></span>
  </button>
</template>

<style scoped>
.base-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.875rem 2.25rem;
  border-radius: 9999px;
  cursor: pointer;
  font-family: 'HND', sans-serif;
  font-weight: 600;
  font-size: 0.9rem;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  transition: 0.2s;
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
  text-decoration: none;
}

.base-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-primary {
  border: none;
  background: linear-gradient(135deg,var(--pink),var(--purple));
  color: #fff;
  font-weight: 700;
}

.btn-primary:hover:not(:disabled) {
  transform: translateY(-0.125rem);
  box-shadow: 0 0.5rem 1.875rem rgba(208, 23, 122, 0.4);
}

.btn-outline {
  background: transparent;
  border: 0.125rem solid rgba(255, 255, 255, 0.25);
  color: #fff;
}

.btn-outline:hover:not(:disabled) {
  border-color: var(--pink-bright);
  color: var(--pink-bright);
}

.base-btn a {
  color: inherit;
  text-decoration: none;
}
</style>
